
import React from 'react';
import { RegularLoader } from './RegularLoader/RegularLoader';
import SmallLoader from './SmallLoader/SmallLoader';

export const Loader = ({ type, loadingText }) => {
	return type === 'regular' ? <RegularLoader loadingText={loadingText} /> : <SmallLoader />;
};
